package org.example.project

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val options = FirebaseOptions(
        applicationId = "1:634573743008:web:81b61008e1862961c6bac5",
        apiKey = "AIzaSyA9DHYVR2SfIqYVL7vkPcdzcqswp9zFhU0",
        projectId = "assoziation-c5cda",
        databaseUrl = "https://assoziation-c5cda-default-rtdb.firebaseio.com"
    )

    // DER FIX: Wir setzen den Context explizit auf null und benennen die options
    Firebase.initialize(context = null, options = options)

    onWasmReady {
        CanvasBasedWindow(canvasElementId = "ComposeTarget", title = "Asocijacija") {
            App()
        }
    }
}